
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ColorPanel from "./color-panel.vue";
import HueSlider from "./hue-slider.vue";
import Color from "../../utils/colorHelper";

@Component({
  components: {
    ColorPanel,
    HueSlider
  }
})
export default class PickerDropdown extends Vue {
  @Prop({ required: true }) color!: Color;
  @Prop({ default: false, type: Boolean }) showAlpha!: boolean;

  visible = false;
  customInput = "";
  get currentColor() {
    return this.color.value;
  }

  handleConfirm() {
    this.color.fromString(this.customInput);
  }

  @Watch("visible")
  changeVisible(val: boolean) {
    if (!val) return;
    this.$nextTick(() => {
      const { cp, hue, alpha } = this.$refs;
      cp && (cp as any).update();
      hue && (hue as any).update();
      alpha && (alpha as any).update();
    });
  }

  @Watch("currentColor", { immediate: true })
  changeColor(val: string) {
    this.customInput = val;
  }
}
